import { useCallback } from "react";

import { useTranslations } from "@jti/ui/providers/useTranslations";

import { useStoreLocatorContext } from "../useStoreLocatorContext";

const DEFAULT_PREFIXES = ["store_locator.", "storelocator."];

export const useLocatorTranslations = () => {
  const { __ } = useTranslations();
  const { translationPrefix } = useStoreLocatorContext();

  const translate = useCallback(
    (key: string) => {
      if (!translationPrefix) {
        return __(key);
      }

      for (const prefix of DEFAULT_PREFIXES) {
        if (key.startsWith(prefix)) {
          return __(`${translationPrefix}.${key.slice(prefix.length)}`);
        }
      }

      return __(key);
    },
    [__, translationPrefix]
  );

  return { __: translate };
};
